import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

const baseText = 'How to find the right'

const findTheRightCardData: Record<
    CreditCardProductCategory,
    { supportingText: string; title: string }
> = {
    ['BalanceTransfer']: {
        title: `${baseText} balance transfer card`,
        supportingText:
            'Finding your best balance transfer will depend on how much debt you have, your credit score, and how quickly you can pay it back.',
    },

    ['BestCards']: {
        title: `${baseText} credit card`,
        supportingText:
            'Finding the right card depends on what you need it for and your personal financial situation.',
    },

    ['Cashback']: {
        title: `${baseText} cashback card`,
        supportingText:
            "Finding the best cashback card depends on your own personal spending habits, how often you use the card, what you use it for, and if you're able to clear the balance every month.",
    },

    ['Combined']: {
        title: `${baseText} balance transfer and purchase card`,
        supportingText:
            "The best card depends on your own circumstances. You’ll need to consider if your priority is to clear debt, make purchases, and think about how much you're transferring, and if you can manage two different 0% end dates.",
    },

    ['PoorCredit']: {
        title: `${baseText} credit card`,
        supportingText:
            'The best credit card for you will depend on what you want to use it for. For example, whether you want to pay down debt, improve your credit rating, spread the cost of a large purchase, spend overseas, or earn cashback.',
    },

    ['Purchase']: {
        title: `${baseText} purchase card`,
        supportingText:
            'Finding the best purchase card will depend on how much you need to borrow, your credit score, and how quickly you think you can pay it back.',
    },

    ['Rewards']: {
        title: `${baseText} rewards card`,
        supportingText:
            'Finding the best rewards card depends on where you actually spend your money, how much you spend, and if you’re able to clear the balance in full every month.',
    },

    ['Travel']: {
        title: `${baseText} travel card`,
        supportingText:
            "The best travel card depends on how often you travel, where you're going, whether you'll need to take out cash, and how quickly you can repay what you borrow.",
    },
}

export default findTheRightCardData
